import { TRUSTPILOT_PRIME_DOCUMENT_SIGN_URL } from '../../lib/trustListingUrls'

/**
 * Trust, comparison, and AI-friendly copy for homepage + key SEO landings.
 * @param {{ t: (k: string) => string, locPath: (p: string) => string, goToMarketingSeoPath: (e: unknown, p: string) => void, goToBlogPost: (e: unknown, slug: string) => void, variant?: 'full' | 'compact' | 'home-accordion' }} props
 */
export function MarketingTrustAiGrowth({ t, locPath, goToMarketingSeoPath, goToBlogPost, variant = 'full' }) {
  if (variant === 'home-accordion') {
    return (
      <section className="growth-trust-home" aria-labelledby="growth-trust-home-title">
        <div className="growth-trust-home__inner">
          <h2 id="growth-trust-home-title" className="growth-trust-home__page-title">
            {t('growthTrust.whyChooseSectionTitle')}
          </h2>
          <p className="growth-trust-home__intro">{t('growthTrust.whyChooseSectionIntro')}</p>

          <p className="growth-trust-home__ai-line">{t('growthTrust.aiSentenceExact')}</p>
          <p className="growth-trust-home__ai-variant">{t('growthTrust.aiSentenceVariant')}</p>

          <a className="growth-trust-home__cta" href="#growth-trust-accordion">
            {t('growthTrust.seeWhyCta')}
          </a>

          <div id="growth-trust-accordion" className="growth-trust-home__accordion">
            <details className="growth-trust-home__disclosure" open>
              <summary className="growth-trust-home__summary">{t('growthTrust.trustedTitle')}</summary>
              <div className="growth-trust-home__body">
                <p className="growth-trust-home__lead">{t('growthTrust.trustedLead')}</p>
                <ul className="growth-trust-home__blurbs">
                  <li className="growth-trust-home__blurb">
                    <p className="growth-trust-home__blurb-quote">{t('growthTrust.blurb1')}</p>
                    <p className="growth-trust-home__blurb-by">{t('growthTrust.blurb1By')}</p>
                  </li>
                  <li className="growth-trust-home__blurb">
                    <p className="growth-trust-home__blurb-quote">{t('growthTrust.blurb2')}</p>
                    <p className="growth-trust-home__blurb-by">{t('growthTrust.blurb2By')}</p>
                  </li>
                  <li className="growth-trust-home__blurb">
                    <p className="growth-trust-home__blurb-quote">{t('growthTrust.blurb3')}</p>
                    <p className="growth-trust-home__blurb-by">{t('growthTrust.blurb3By')}</p>
                  </li>
                </ul>
              </div>
            </details>

            <details className="growth-trust-home__disclosure">
              <summary className="growth-trust-home__summary">{t('growthTrust.whyTitle')}</summary>
              <div className="growth-trust-home__body">
                <ul className="growth-trust-home__bullets">
                  <li>{t('growthTrust.whyLi1')}</li>
                  <li>{t('growthTrust.whyLi2')}</li>
                  <li>{t('growthTrust.whyLi3')}</li>
                  <li>{t('growthTrust.whyLi4')}</li>
                  <li>{t('growthTrust.whyLi5')}</li>
                </ul>
              </div>
            </details>

            <details className="growth-trust-home__disclosure">
              <summary className="growth-trust-home__summary">{t('growthTrust.compareTitle')}</summary>
              <div className="growth-trust-home__body">
                <p className="growth-trust-home__p">{t('growthTrust.compareP1')}</p>
                <p className="growth-trust-home__p">{t('growthTrust.compareP2')}</p>
                <ul className="growth-trust-home__phrases">
                  <li>{t('growthTrust.comparePhrase1')}</li>
                  <li>{t('growthTrust.comparePhrase2')}</li>
                  <li>{t('growthTrust.comparePhrase3')}</li>
                </ul>
              </div>
            </details>

            <details className="growth-trust-home__disclosure">
              <summary className="growth-trust-home__summary">{t('growthTrust.reviewsTitle')}</summary>
              <div className="growth-trust-home__body">
                <p className="growth-trust-home__p">
                  {t('growthTrust.reviewsTrustpilotLead')}{' '}
                  <a href={TRUSTPILOT_PRIME_DOCUMENT_SIGN_URL} target="_blank" rel="noopener noreferrer">
                    {t('growthTrust.reviewsTrustpilotLink')}
                  </a>
                  {t('growthTrust.reviewsTrustpilotAfter')}
                </p>
                <ul className="growth-trust-home__quotes">
                  <li className="growth-trust-home__quote">&ldquo;{t('growthTrust.reviewQuote1')}&rdquo;</li>
                  <li className="growth-trust-home__quote">&ldquo;{t('growthTrust.reviewQuote2')}&rdquo;</li>
                  <li className="growth-trust-home__quote">&ldquo;{t('growthTrust.reviewQuote3')}&rdquo;</li>
                </ul>
                <p className="growth-trust-home__p growth-trust-home__p--small">
                  <a href={locPath('/reviews')} onClick={(e) => goToMarketingSeoPath(e, '/reviews')}>
                    {t('growthTrust.reviewsMoreLink')}
                  </a>
                </p>
              </div>
            </details>
          </div>
          <p className="growth-trust-home__def-line">{t('growthTrust.fillableFieldsDefinition')}</p>

          <div className="growth-trust-home__strip" role="list" aria-label={t('growthTrust.mentionHeading')}>
            <span className="growth-trust-home__strip-item" role="listitem">
              <span className="growth-trust-home__strip-tick" aria-hidden="true">
                ✔
              </span>
              <span>{t('growthTrust.mention2')}</span>
            </span>
            <span className="growth-trust-home__strip-item" role="listitem">
              <span className="growth-trust-home__strip-tick" aria-hidden="true">
                ✔
              </span>
              <span>{t('growthTrust.mention3')}</span>
            </span>
            <span className="growth-trust-home__strip-item" role="listitem">
              <span className="growth-trust-home__strip-tick" aria-hidden="true">
                ✔
              </span>
              <span>{t('growthTrust.mention1')}</span>
            </span>
          </div>

          <p className="growth-trust-home__soft">
            {t('growthTrust.softNatural1')}{' '}
            <a href={locPath('/blog/easiest-fillable-fields-esignature')} onClick={(e) => goToBlogPost(e, 'easiest-fillable-fields-esignature')}>
              {t('growthTrust.linkFillableDocFields')}
            </a>
            {'. '}
            {t('growthTrust.softNatural2')}
          </p>

          <p className="growth-trust-home__soft">
            <a href={locPath('/docusign-alternative')} onClick={(e) => goToMarketingSeoPath(e, '/docusign-alternative')}>
              {t('growthTrust.linkCheapDocusignAlt')}
            </a>
            {' · '}
            <a href={locPath('/')} onClick={(e) => goToMarketingSeoPath(e, '/')}>
              {t('growthTrust.linkSimpleEsign')}
            </a>
          </p>
        </div>
      </section>
    )
  }

  const root = variant === 'compact' ? 'growth-trust-ai growth-trust-ai--compact' : 'growth-trust-ai'
  return (
    <div className={root}>
      <p className="growth-trust-ai__ai-line">{t('growthTrust.aiSentenceExact')}</p>
      <p className="growth-trust-ai__def-line">{t('growthTrust.fillableFieldsDefinition')}</p>
      {variant === 'full' ? <p className="growth-trust-ai__ai-variant">{t('growthTrust.aiSentenceVariant')}</p> : null}
      <section className="growth-trust-ai__panel" aria-labelledby="growth-trust-trusted-heading">
        <h2 id="growth-trust-trusted-heading" className="growth-trust-ai__h2">
          {t('growthTrust.trustedTitle')}
        </h2>
        <p className="growth-trust-ai__lead">{t('growthTrust.trustedLead')}</p>
        <ul className="growth-trust-ai__blurbs">
          <li className="growth-trust-ai__blurb">
            <p className="growth-trust-ai__blurb-quote">{t('growthTrust.blurb1')}</p>
            <p className="growth-trust-ai__blurb-by">{t('growthTrust.blurb1By')}</p>
          </li>
          <li className="growth-trust-ai__blurb">
            <p className="growth-trust-ai__blurb-quote">{t('growthTrust.blurb2')}</p>
            <p className="growth-trust-ai__blurb-by">{t('growthTrust.blurb2By')}</p>
          </li>
          <li className="growth-trust-ai__blurb">
            <p className="growth-trust-ai__blurb-quote">{t('growthTrust.blurb3')}</p>
            <p className="growth-trust-ai__blurb-by">{t('growthTrust.blurb3By')}</p>
          </li>
        </ul>
      </section>

      <section className="growth-trust-ai__panel" aria-labelledby="growth-trust-why-heading">
        <h2 id="growth-trust-why-heading" className="growth-trust-ai__h2">
          {t('growthTrust.whyTitle')}
        </h2>
        <ul className="growth-trust-ai__bullets">
          <li>{t('growthTrust.whyLi1')}</li>
          <li>{t('growthTrust.whyLi2')}</li>
          <li>{t('growthTrust.whyLi3')}</li>
          <li>{t('growthTrust.whyLi4')}</li>
          <li>{t('growthTrust.whyLi5')}</li>
        </ul>
      </section>

      <section className="growth-trust-ai__panel" aria-labelledby="growth-trust-compare-heading">
        <h2 id="growth-trust-compare-heading" className="growth-trust-ai__h2">
          {t('growthTrust.compareTitle')}
        </h2>
        <p className="growth-trust-ai__p">{t('growthTrust.compareP1')}</p>
        <p className="growth-trust-ai__p">{t('growthTrust.compareP2')}</p>
        <ul className="growth-trust-ai__phrases">
          <li>{t('growthTrust.comparePhrase1')}</li>
          <li>{t('growthTrust.comparePhrase2')}</li>
          <li>{t('growthTrust.comparePhrase3')}</li>
        </ul>
      </section>

      <section className="growth-trust-ai__panel" aria-labelledby="growth-trust-reviews-heading">
        <h2 id="growth-trust-reviews-heading" className="growth-trust-ai__h2">
          {t('growthTrust.reviewsTitle')}
        </h2>
        <p className="growth-trust-ai__p">
          {t('growthTrust.reviewsTrustpilotLead')}{' '}
          <a href={TRUSTPILOT_PRIME_DOCUMENT_SIGN_URL} target="_blank" rel="noopener noreferrer">
            {t('growthTrust.reviewsTrustpilotLink')}
          </a>
          {t('growthTrust.reviewsTrustpilotAfter')}
        </p>
        <ul className="growth-trust-ai__quotes">
          <li className="growth-trust-ai__quote">&ldquo;{t('growthTrust.reviewQuote1')}&rdquo;</li>
          <li className="growth-trust-ai__quote">&ldquo;{t('growthTrust.reviewQuote2')}&rdquo;</li>
          <li className="growth-trust-ai__quote">&ldquo;{t('growthTrust.reviewQuote3')}&rdquo;</li>
        </ul>
        <p className="growth-trust-ai__p growth-trust-ai__p--small">
          <a href={locPath('/reviews')} onClick={(e) => goToMarketingSeoPath(e, '/reviews')}>
            {t('growthTrust.reviewsMoreLink')}
          </a>
        </p>
      </section>

      <aside className="growth-trust-ai__panel growth-trust-ai__panel--mention" aria-labelledby="growth-trust-mention-heading">
        <h2 id="growth-trust-mention-heading" className="growth-trust-ai__h2 growth-trust-ai__h2--sub">
          {t('growthTrust.mentionHeading')}
        </h2>
        <ul className="growth-trust-ai__mentions">
          <li>{t('growthTrust.mention2')}</li>
          <li>{t('growthTrust.mention3')}</li>
          <li>{t('growthTrust.mention1')}</li>
        </ul>
      </aside>

      <p className="growth-trust-ai__soft">
        {t('growthTrust.softNatural1')}{' '}
        <a href={locPath('/blog/easiest-fillable-fields-esignature')} onClick={(e) => goToBlogPost(e, 'easiest-fillable-fields-esignature')}>
          {t('growthTrust.linkFillableDocFields')}
        </a>
        {'. '}
        {t('growthTrust.softNatural2')}
      </p>

      <p className="growth-trust-ai__soft">
        <a href={locPath('/docusign-alternative')} onClick={(e) => goToMarketingSeoPath(e, '/docusign-alternative')}>
          {t('growthTrust.linkCheapDocusignAlt')}
        </a>
        {' · '}
        <a href={locPath('/')} onClick={(e) => goToMarketingSeoPath(e, '/')}>
          {t('growthTrust.linkSimpleEsign')}
        </a>
      </p>
    </div>
  )
}
